export default __webpack_public_path__ + "static/media/follow-dao.4a5d5b66.webp";